import apivendas from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }] = await Promise.all([
        apivendas.get('venda', { params: { ...where, ...params } }),
      ]);

      return data;
    },

    async resumopedidos(_, { where }) {
      console.log('resumo where', where, { where });
      const [{ data }] = await Promise.all([
        apivendas.get('pedidovenda/resumo', { params: where }),
      ]);
      return data;
    },

    async resumopedidosbyvendedor(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('pedidovenda/resumo/vendedor', { params: where }),
      ]);
      return data;
    },

    async resumopedidosbyregiao(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('pedidovenda/resumo/regiao', { params: where }),
      ]);
      return data;
    },

    async resumopedidosbycliente(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('pedidovenda/resumo/cliente', { params: where }),
      ]);
      return data;
    },

    async detalhado(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('pedidovenda/detalhado', { params: where }),
      ]);
      return data;
    },

    async produtos(_, { where }) {
      const [{ data }] = await Promise.all([
        apivendas.get('pedidovendaitem/produtos', { params: where }),
      ]);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    loading(state, request) {
      state.loading = request ?? false;
    },
  },
};
